<template>
  <div>
    <!-- Modal -->
    <div id="payment-modal">
      <div id="payment-modal-wrapper">
        <div class="modal fade show"
             tabindex="-1" role="dialog"
             aria-labelledby="exampleModalCenterTitle"
             aria-hidden="true"
             style="display: block"
        >
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="close">
                  <span class="close-span" aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <ul class="nav nav-tabs ul-payment">
                  <li class="nav-item nav-payment" @click.prevent="creditCard = false">
                    <a :class="{'nav-link tab-link': true, 'active': !creditCard}">
                      {{ $t('paypal') }}
                    </a>
                  </li>
                  <li class="nav-item nav-payment" @click.prevent="creditCard = true">
                    <a :class="{'nav-link tab-link': true, 'active': creditCard}">
                      {{ $t('creditCard') }}
                    </a>
                  </li>
                </ul>
                <CreditCard
                    :formActionUrl="formActionUrl"
                    :active="creditCard"
                ></CreditCard>
                <ExternalPaymentsCard
                    :formActionUrl="formActionUrl"
                    :active="!creditCard"
                ></ExternalPaymentsCard>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaymentModal from './PaymentModal';
export default PaymentModal;
</script>

<style lang="scss" scoped>
ul {
  margin-bottom: 10px;
}
.modal-header {
  background: #002e56;
  button {
    color: white;
  }
}
.modal-content {
  border: 0;
}
.modal-body {
  max-width: 480px;
  margin: 10px auto;
}
.nav-payment {
  cursor: pointer;
}

.nav-item a {
  font-size: 18px;
  opacity: 0.5;
  padding-left: 0;
  padding-right: 0;
  margin-right: 20px;
  text-transform: uppercase;
  font-weight: 800;
  color: black;
}

.nav-item a.active {
  background-color: inherit;
  border: 0;
  border-bottom: 2px solid #ed1c24;
  color: #333;
  opacity: 1;
}
</style>
